<template>
    <div class="login-main">
        <!-- 头部 -->
        <div class="top-box">
            <div :class="{ 'top-left': true, 'top-getBack': loginType == 5 || loginType == 6 ? true : false }">{{
                $t(phoneLoginTitle) }}
            </div>
            <div class="top-right" v-if="loginType == 4 || loginType == 5 || loginType == 6 ? false : true">
                <!-- 二维码登录 -->
                <div style="cursor: pointer;" @click="loginTypeBut(4)">{{ $t('phoneLogin.loginQR') }}</div>
                <!-- 密码登录 -->
                <div @click="loginTypeBut(2)" v-show="loginType == 2 ? false : loginType == 3 ? false : true"
                    :style="{ marginLeft: '0.18rem', cursor: 'pointer' }">{{
                $t('phoneLogin.loginPass') }}</div>
                <!-- 验证码登录 -->
                <div @click="loginTypeBut(1)" v-show="loginType != 1 ? loginType == 3 ? false : true : false"
                    :style="{ marginLeft: '0.18rem', cursor: 'pointer' }">{{ $t('phoneLogin.verificationCodeLogin') }}
                </div>
            </div>
            <!-- 邮箱登录 -->
            <div v-if="loginType == 4 ? true : false" class="top-right">
                <div style="cursor: pointer;" @click="loginTypeBut(3)">{{ $t('phoneLogin.emailLogin') }}</div>
            </div>
            <!-- 邮箱找回密码-->
            <div v-if="loginType == 5 ? true : false" class="get-password">
                <div style="cursor: pointer;" @click="loginTypeBut(6)">{{ $t('phoneLogin.getEmailPassword') }}</div>
            </div>
            <!-- 手机验证码找回密码 -->
            <div v-if="loginType == 6 ? true : false" class="get-password">
                <div style="cursor: pointer;" @click="loginTypeBut(5)">{{ $t('phoneLogin.getBackPhonePassword') }}</div>
            </div>
        </div>
        <!-- 手机验证码--密码登录 -->
        <div class="password-login-box" v-if="loginType == 1 ? true : loginType == 2 ? true : false">
            <!-- 输入手机号 -->
            <div class="password-input">
                <!-- 选择区号 -->
                <div class="password-input-left" @click="rotateIconBut">
                    <div :style="{ marginRight: '0.1rem' }">+{{ checkedCode }}</div>
                    <svg t="1652858954540" :class="{ 'rotate-icon': rotateIcon }" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="6409" data-spm-anchor-id="a313x.7781069.0.i10"
                        width="13" height="13">
                        <path
                            d="M944.083879 289.536302c14.264888 18.286482 15.462157 41.208541 2.670829 51.196009l-417.191704 325.421604c-2.885723 2.261507-12.156878 7.828292-13.732769 9.578146-15.544021 17.181311-37.893029 22.338774-49.947576 11.461029l-392.908648-354.309538c-12.054547-10.887978-9.271154-33.666774 6.272867-50.889017 15.544021-17.21201 37.893029-22.349007 49.988508-11.471262l357.584118 322.443783 408.258241-318.463122C907.910005 264.516466 929.84969 271.260054 944.083879 289.536302z"
                            p-id="6410" data-spm-anchor-id="a313x.7781069.0.i9" class="selected"></path>
                    </svg>
                </div>
                <!-- 选择区号弹窗 -->
                <div class="select-phone" v-show="rotateIcon" id="select_phone">
                    <div v-for="item in regionList" :key="item.type">
                        <div class="select-phone-type">{{ item.type }}</div>
                        <div :style="{ color: val.tel_code == checkedCode ? '#000000' : '#888' }"
                            class="select-phone-item" v-for="val in item.datalist" :key="val.tel_code"
                            @click="pickCode(val)">
                            <div>{{ setSelectPhoneItem(val) }}</div>
                            <div>+{{ val.tel_code }}</div>
                        </div>
                    </div>
                </div>
                <!-- 手机号输入框 -->
                <input :spellcheck="false" class="password-input-right" :placeholder="$t('phoneLogin.Phoneplaceholder')"
                    v-model="formData.phone" maxlength="12" type="text">
                <!-- 发送验证码 -->
                <a v-show="sendCodeShow == true ? loginType == 1 ? true : false : false" @click="sendCode"
                    class="password-input-send" style="color: #3D63C4; cursor: pointer;">
                    {{ $t('phoneLogin.SendverificationCode') }}
                </a>
                <a v-show="sendCodeShow == true ? false : loginType == 1 ? true : false"
                    class="password-input-send sendCodeTime">
                    {{ sendCodeTime }}
                </a>
                <!-- 发送验证码占位元素 -->
                <a class="password-input-send" v-show="loginType != 1 ? true : false"></a>
            </div>
            <div class="password-line"></div>
            <!-- 输入短信验证码 -->
            <div class="password-input">
                <!-- code -->
                <div v-show="loginType == 1 ? true : false" class="password-input-left">
                    {{ $t('phoneLogin.verificationCode') }}
                </div>
                <!-- password -->
                <div v-show="loginType == 2 ? true : false" class="password-input-left">
                    {{ $t('phoneLogin.passwordLogin') }}
                </div>
                <input :spellcheck="false" class="password-input-right"
                    :placeholder="loginType == 1?'Please enter Verification code':'Please enter Password'" v-model="formData.phonePassword"
                    :maxlength="loginType == 1 ? 6 : 18" :type="loginType == 1 ? 'text' : 'password'">
                <a class="password-input-send"></a>
            </div>
            <!-- 密码或验证码登录 -->
            <div class="password-login" @click="loginBut">{{ $t('phoneLogin.loginBut') }}</div>
        </div>
        <!-- 二维码登录  -->
        <div class="Qr-code-login" v-if="loginType == 4 ? true : false">
            <div class="VueQrcode-box" @click="resetQrCode">
                <VueQrcode :value="qrCodeUUID" :style="{ width: '2rem' }"></VueQrcode>
                <div class="qrcode-img">
                    <img v-show="qrRefreshImg == false ? true : false" src="@/assets/29x29.png">
                    <img v-show="qrRefreshImg == false ? false : true" src="@/assets/reset-ion.png" alt="">
                </div>
            </div>
            <div class="VueQrcode-fonts" v-show="qrCodeUUIDstatus == 1 && qrRefreshImg == false?true:false">{{ $t('phoneLogin.qrTitles') }}</div>
            <div class="VueQrcode-fonts" v-show="qrCodeUUIDstatus == 2?true:false">Scanning code success! Please confirm login on your phone</div>
            <div class="VueQrcode-fonts" v-show="qrRefreshImg == true?true:false">Qr code expired, please refresh</div>
        </div>
        <!-- 邮箱登录 -->
        <div class="email-login" v-if="loginType == 3 ? true : false">
            <input type="text" v-model="passWordLogin.username" :spellcheck="false" class="email-login-input"
                :placeholder="$t('phoneLogin.emailInput')">
            <div class="email-login-input-line"></div>
            <input v-model="passWordLogin.password" type="password" :spellcheck="false" class="email-login-input"
                :placeholder="$t('phoneLogin.emailInputPass')">
            <div :class="{ 'email-login-button': true }" @click="submitLogin">{{ $t('phoneLogin.loginBut') }}</div>
        </div>
        <!-- 找回密码 手机号 | 邮箱 -->
        <div class="getPhoneOrEmailPassword-box" v-if="loginType == 5 || loginType == 6 ? true : false">
            <div class="phone-email-input">
                <div class="phone-code" @click="rotateIconBut" v-if="loginType == 6 ? false : true">
                    <div :style="{ marginRight: '0.1rem' }">+{{ checkedCode }}</div>
                    <svg t="1652858954540" :class="{ 'rotate-icon': rotateIcon }" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="6409" data-spm-anchor-id="a313x.7781069.0.i10"
                        width="13" height="13">
                        <path
                            d="M944.083879 289.536302c14.264888 18.286482 15.462157 41.208541 2.670829 51.196009l-417.191704 325.421604c-2.885723 2.261507-12.156878 7.828292-13.732769 9.578146-15.544021 17.181311-37.893029 22.338774-49.947576 11.461029l-392.908648-354.309538c-12.054547-10.887978-9.271154-33.666774 6.272867-50.889017 15.544021-17.21201 37.893029-22.349007 49.988508-11.471262l357.584118 322.443783 408.258241-318.463122C907.910005 264.516466 929.84969 271.260054 944.083879 289.536302z"
                            p-id="6410" data-spm-anchor-id="a313x.7781069.0.i9" class="selected"></path>
                    </svg>
                </div>
                <!-- 选择区号弹窗 -->
                <div class="select-phone" v-show="rotateIcon" id="select_phone">
                    <div v-for="item in regionList" :key="item.type">
                        <div class="select-phone-type">{{ item.type }}</div>
                        <div :style="{ color: val.tel_code == checkedCode ? '#000000' : '#888' }"
                            class="select-phone-item" v-for="val in item.datalist" :key="val.tel_code"
                            @click="pickCode(val)">
                            <div>{{ setSelectPhoneItem(val) }}</div>
                            <div>+{{ val.tel_code }}</div>
                        </div>
                    </div>
                </div>
                <input type="text" class="import-input-PorE" :spellcheck="false"
                    :placeholder="$t(getBackPlaceholderPorE)" v-model="getPasswordFrom.emailOrPhone">
                <!-- 发送验证码 -->
                <a class="getpassword-send-code" v-if="getBackTimeShow == false ? true : false"
                    @click="getBackSendCode">{{ $t('phoneLogin.getPasswordSendCode') }}</a>
                <!-- 倒计时 -->
                <a v-if="getBackTimeShow == true ? true : false" class="getpassword-send-code">
                    {{ getBackTime }}
                </a>
            </div>
            <div class="input-line"></div>
            <input type="text" class="import-code-input" :spellcheck="false"
                :placeholder="$t('phoneLogin.phonePasswordPlaceholder')" v-model="getPasswordFrom.emailOrPhoneCode">
            <div class="input-line"></div>
            <input type="password" class="import-code-input" :spellcheck="false"
                :placeholder="$t('phoneLogin.importPassword')" v-model="getPasswordFrom.newPassword">
            <div class="getBack-Button" @click="getBackSubmit">{{ $t('phoneLogin.submit') }}</div>
        </div>
        <!-- 切换登录方式 -->
        <div class="retrieve-password">
            <!-- 找回密码  -->
            <div v-show="loginType == 3 || loginType == 2 ? true : false" style="cursor: pointer;"
                @click="loginTypeBut(5)">{{
                $t('phoneLogin.forgotPassword') }}
            </div>
            <!-- 手机号登录 -->
            <div @click="loginTypeBut(1)" v-show="loginType == 4 && lang != 'zh' || loginType == 3 ? true : false"
                style="cursor: pointer;">{{
                $t('phoneLogin.loginWithMobiles') }}
            </div>
            <!-- 邮箱登录 -->
            <div @click="loginTypeBut(3)"
                v-show="lang != 'zh' && loginType == 1 || lang != 'zh' && loginType == 2 ? true : false"
                style="cursor: pointer;">{{ $t('phoneLogin.emailLogin') }}
            </div>
            <!-- 手机号登录 -->
            <div style="cursor: pointer;" @click="loginTypeBut(1)"
                v-show="loginType == 5 || loginType == 6 ? true : false"> {{ $t('phoneLogin.loginWithMobiles') }}</div>
        </div>

        <!-- 其他登录方式 -->
        <div class="other-login" v-if="loginType == 5 || loginType == 6 ? false : true">
            <div class="other-title">{{ $t('phoneLogin.loginByOtherMeans') }}</div>
            <div class="other-item">
                <img src="@/assets/login_icon2.png" class="other-item-wx" @click="goWxLogin">
                <img src="@/assets/login_icon3.png" class="other-item-pg" @click="goAppleLogin">
                <img src="@/assets/Google (2).png" class="other-item-pg" @click="goGoogleLogin">
                <!-- <div id="googleBtn"></div> -->
            </div>

        </div>
        <!-- 验证码 -->
        <Verify @success="success" :veifyTitle="$t('phoneLogin.veifyTitle')" :explain="$t('phoneLogin.explain')"
            captchaType="clickWord" :userName="userPhone" :getType="loginType"
            :imgSize="{ width: '330px', height: '155px' }" ref="verify">
        </Verify>
        <!-- 弹窗 -->
        <div class="dialog-message" v-show="dialogFontIsShow">
            <div class="dialog-message-title">{{ $t(MessageTitle) }}</div>
            <div class="dialog-message-content">{{ msgMessageContent == '' ? $t(MessageContent) : msgMessageContent }}
            </div>
            <div @click="dialogFontIsShowBut" class="dialog-message-button">{{ $t(MessageButton) }}</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, ref, computed, onMounted } from 'vue'
import { getShowTelCode, loginPassword, loginPhone, loginScan, listenScan, forgotPasswordByPhone, forgotPasswordByEmail, googleLogin } from '@/api/modules/login'
import Verify from './verifition/Verify.vue'
import VueQrcode from 'vue-qrcode'
import axios from 'axios'
import { useRouter } from 'vue-router'

export default {
    name: 'LoginWindow',
    components: {
        Verify,
        VueQrcode
    },
    props: {
        setUserInfo: {
            type: Function
        }
    },
    setup(props) {
        const router = useRouter()
        const verify = ref()
        const state = reactive({
            formData: {
                phone: '',// 手机号
                phonePassword: '',// 密码 || 验证码
            },
            passWordLogin: {
                username: '',//邮箱或者手机号，邮箱格式xxx@xx.xx，手机号(区号和手机号中间横杠"-"拼接)xx-xxx
                password: '',// 登录密码，支持6~18位，其它不限制
            },
            getPasswordFrom: {
                emailOrPhone: '',// 找回密码输入框绑定值
                emailOrPhoneCode: '',// 找回密码验证码
                newPassword: '',// 新密码
            },
            reg: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,//邮箱验证
            dialogFontIsShow: false,// 提示弹窗
            dialogFonts: '',// 弹窗内容多语言
            MessageTitle: '',// 弹窗title
            MessageContent: '',// 弹窗内容
            msgMessageContent: '', // 接口返回内容
            MessageButton: '',// 弹窗确认按钮
            checkedCode: '86', // 国际号码
            rotateIcon: false, // 选择区号箭头朝向 | 选择区号弹窗
            regionList: [], // 排序好的国际区号
            lang: '',
            sendCodeTime: 60,
            sendCodeShow: true,// 关闭发送验证码按钮
            getBackTime: 60,// 找回密码剩余时间
            getBackTimeShow: false,// 找回密码发送验证码按钮 false | 发送验证码， true | 剩余时间
            timer: null,// 手机验证码登录倒计时
            getBacktimer: null,// 找回密码倒计时
            phoneLoginTitle: 'phoneLogin.title',
            qrCodeUUID: '',//二维码登录
            qrUUIDTime: '',//过期毫秒
            qrCodeUUIDstatus:1,// 扫码状态
            qrRefreshImg: false,// 刷新二维码
            qrSetIntervar: '',// 定时器 用于轮询接口
            qrSetTimeout: '',// 定时器 用于验证码过期
            getBackPlaceholderPorE: '',// 找回密码
            loginType: 1,// 登录方式 ，1 手机验证码登录，2 手机密码登录 3 邮箱登录 4 二维码登录 5 手机号密码找回 6邮箱找回密码
        })
        let userPhone = computed(() => {
            switch (state.loginType) {
                case 1:
                    return state.formData.phone ? state.checkedCode + '-' + state.formData.phone : ''
                case 5:
                    return state.getPasswordFrom.emailOrPhone ? state.checkedCode + '-' + state.getPasswordFrom.emailOrPhone : ''
                case 6:
                    return state.getPasswordFrom.emailOrPhone ? state.getPasswordFrom.emailOrPhone : ''
            }
        })
        onMounted(() => {
            state.lang = localStorage.getItem('2d3d-language')
            if(!localStorage.getItem('token')){
                getData()
            }
        })
        /**
         * 登录方式切换
         */
        function loginTypeBut(type) {
            clearTimeout(state.qrSetTimeout)
            clearInterval(state.qrSetIntervar)
            clearTimeout(state.timer)
            clearTimeout(state.getBacktimer)
            state.qrRefreshImg = false
            state.rotateIcon = false
            switch (type) {
                case 1: //1 手机验证码登录
                    state.checkedCode = '86'
                    state.loginType = 1
                    state.sendCodeTime = 60
                    state.sendCodeShow = true
                    state.formData.phone = ''
                    state.formData.phonePassword = ''
                    state.phoneLoginTitle = 'phoneLogin.title'
                    break;
                case 2: //2 手机密码登录
                    state.loginType = 2
                    state.formData.phone = ''
                    state.formData.phonePassword = ''
                    state.phoneLoginTitle = 'phoneLogin.title'
                    break;
                case 3: //3 邮箱登录
                    state.loginType = 3
                    state.passWordLogin.username = ''
                    state.passWordLogin.password = ''
                    state.phoneLoginTitle = 'phoneLogin.emailLogin'
                    break;
                case 4: //4 二维码登录
                    state.loginType = 4
                    getUUID()
                    state.phoneLoginTitle = 'phoneLogin.loginWithQRcode'
                    break;
                case 5: //5 密码找回
                    state.loginType = 5
                    state.getBackTimeShow = false
                    state.getBackTime = 60
                    state.phoneLoginTitle = 'phoneLogin.getBackPhonePassword'
                    state.getBackPlaceholderPorE = 'phoneLogin.Phoneplaceholder'
                    state.rotateIcon = false
                    state.checkedCode = '86'
                    state.getPasswordFrom.emailOrPhone = ''
                    state.getPasswordFrom.emailOrPhoneCode = ''
                    state.getPasswordFrom.newPassword = ''
                    break;
                case 6: //6 邮箱找回密码
                    state.loginType = 6
                    state.getBackTimeShow = false
                    state.getBackTime = 60
                    state.phoneLoginTitle = 'phoneLogin.getEmailPassword'
                    state.getBackPlaceholderPorE = 'phoneLogin.emailInput'
                    state.rotateIcon = false
                    state.checkedCode = '86'
                    state.getPasswordFrom.emailOrPhone = ''
                    state.getPasswordFrom.emailOrPhoneCode = ''
                    state.getPasswordFrom.newPassword = ''
                    break;
            }
        }
        // 加载谷歌SDK；
        function onGooogleInit() {
            let script = document.createElement('script');
            script.src = 'https://accounts.google.com/gsi/client';
            document.body.appendChild(script);
        }
        // 谷歌登录
        async function goGoogleLogin() {
            try {
                onGooogleInit()
                const client = google.accounts.oauth2.initTokenClient({
                    client_id: '888529084945-b2jafbq4i17q1qh7ebaoa9dpe7g0mknj.apps.googleusercontent.com',
                    scope: "profile email openid",
                    callback: (response) => {
                        let obj = {
                            credential: response.access_token,
                            g_csrf_token: response.access_token,
                            state: 'integral'
                        }
                        axios.post('https://gb.kokoni.ltd/index/v3/ActionRegister/googleLogin', obj, {
                            headers: {
                                'source': 'integral'
                            }
                        }).then((data_res) => {
                            localStorage.setItem('token', data_res.data.data.token)
                            location.reload()
                        })
                    }
                })
                client.requestAccessToken() // 弹窗登录
            } catch (e) {
                state.msgMessageContent = 'Please check the network'
                state.MessageButton = 'verify'
                state.dialogFontIsShow = true
            }
        }

        // 苹果登录
        function goAppleLogin() {
            window.AppleID.auth.signIn();
        }
        // 微信登录;
        function goWxLogin() {
            let callback = "http://www.kokoni.ltd/index/v3/ActionRegister/wxLogin"
            let link = "https://open.weixin.qq.com/connect/qrconnect?"
            let loginLink = encodeURIComponent(callback)
            window.location.href = link + "appid=wx63586d3a7f3a77cf" + "&redirect_uri=" + loginLink + "&response_type=code" + "&scope=snsapi_login" + "&state=integral"
        }
        // 弹窗
        function dialogFontIsShowBut() {
            state.msgMessageContent = ''
            state.dialogFontIsShow = false
        }
        // 找回密码按钮
        async function getBackSubmit() {
            if (state.loginType == 5) {
                let res = await forgotPasswordByPhone({
                    phone: state.checkedCode + '-' + state.getPasswordFrom.emailOrPhone,
                    phone_code: state.getPasswordFrom.emailOrPhoneCode,
                    password: state.getPasswordFrom.newPassword
                })
                if (res.code == 200) {
                    state.MessageTitle = 'phoneLogin.successMessageTitle'
                    state.MessageContent = res.msg
                    state.MessageButton = 'phoneLogin.MessageButton'
                    state.dialogFontIsShow = true
                } else {
                    state.MessageTitle = 'phoneLogin.errorMessageTitle'
                    state.MessageContent = res.msg
                    state.MessageButton = 'phoneLogin.MessageButton'
                    state.dialogFontIsShow = true
                }
            } else {
                let res = await forgotPasswordByEmail({
                    email: state.getPasswordFrom.emailOrPhone,
                    email_code: state.getPasswordFrom.emailOrPhoneCode,
                    password: state.getPasswordFrom.newPassword
                })
                if (res.code == 200) {
                    state.MessageTitle = 'phoneLogin.successMessageTitle'
                    state.MessageContent = res.msg
                    state.MessageButton = 'phoneLogin.MessageButton'
                    state.dialogFontIsShow = true
                } else {
                    state.MessageTitle = 'phoneLogin.errorMessageTitle'
                    state.MessageContent = res.msg
                    state.MessageButton = 'phoneLogin.MessageButton'
                    state.dialogFontIsShow = true
                }
            }
        }
        // 点选验证码成功后
        function success(res) {
            if (res.code == 200) {
                if (state.loginType == 1) {
                    state.sendCodeShow = false
                    countdown()
                } else {
                    state.getBackTimeShow = true
                    getBackTime()
                }
            }
        }
        // 发送短信倒计时
        function countdown() {
            if (state.sendCodeTime === 0) {
                clearTimeout(state.timer);
                state.sendCodeTime = 60
                state.sendCodeShow = true
            } else {
                state.sendCodeTime--;
                state.timer = setTimeout(countdown, 1000);
            }
        }
        // 找回密码发送短信倒计时
        function getBackTime() {
            if (state.getBackTime === 0) {
                clearTimeout(state.getBacktimer);
                state.getBackTime = 60
                state.getBackTimeShow = false
            } else {
                state.getBackTime--;
                state.getBacktimer = setTimeout(getBackTime, 1000);
            }
        }
        // 点击发送短息 
        function sendCode() {
            if (state.formData.phone != '') {
                verify.value.show() // 调用验证码
            } else {
                state.MessageTitle = 'phoneLogin.errorMessageTitle'
                state.MessageContent = 'phoneLogin.Phoneplaceholder'
                state.MessageButton = 'phoneLogin.MessageButton'
                state.dialogFontIsShow = true
            }
        }
        // 找回密码发送验证码
        function getBackSendCode() {
            if (state.loginType == 5) {
                if (state.getPasswordFrom.emailOrPhone != '') {
                    verify.value.show() // 调用验证码
                } else {
                    state.MessageTitle = 'phoneLogin.errorMessageTitle'
                    state.MessageContent = 'phoneLogin.Phoneplaceholder'
                    state.MessageButton = 'phoneLogin.MessageButton'
                    state.dialogFontIsShow = true
                }
            } else {
                let verifytest = state.reg.test(state.getPasswordFrom.emailOrPhone)
                if (verifytest && state.getPasswordFrom.emailOrPhone != '') {
                    verify.value.show() // 调用验证码
                } else {
                    state.MessageTitle = 'phoneLogin.errorMessageTitle'
                    state.MessageContent = 'phoneLogin.incorrectEmail'
                    state.MessageButton = 'phoneLogin.MessageButton'
                    state.dialogFontIsShow = true
                }
            }
        }
        // 二维码登录刷新二维码
        function resetQrCode() {
            if (state.qrRefreshImg == false) return
            clearTimeout(state.qrSetTimeout)
            clearInterval(state.qrSetIntervar)
            getUUID()
            state.qrRefreshImg = false
            state.qrCodeUUIDstatus = 1
        }
        // 二维码扫码登录
        async function getUUID() {
            let res = await loginScan()
            if (res.code == 200) {
                state.qrUUIDTime = res.data.expire_ttl * 1000 //过期时间
                state.qrCodeUUID = res.data.uuid
                state.qrSetIntervar = setInterval(() => { // 轮询接口
                    getScen()
                }, 3000)
                state.qrSetTimeout = setTimeout(() => { //验证码过期
                    clearInterval(state.qrSetIntervar)
                    state.qrRefreshImg = true
                }, state.qrUUIDTime)
            }
        }
        // 二维码轮询是否登录
        async function getScen() {
            let res = await listenScan({
                scene: 'integral',
                uuid: state.qrCodeUUID
            })
            if (res.code == 200) {
                state.qrCodeUUIDstatus = res.data.status
                if (res.data.status == 3) {
                    clearInterval(state.qrSetIntervar)
                    let info = {
                        data: res.data.info
                    }
                    props.setUserInfo(info)
                }
            } else {
                clearInterval(state.qrSetIntervar)
                state.qrRefreshImg = false
            }

        }
        // 邮箱密码登录
        async function submitLogin() {
            let verify = state.reg.test(state.passWordLogin.username)
            if (state.passWordLogin.username != '' && state.passWordLogin.password != '' && verify) {
                if (state.passWordLogin.password.length > 18 || state.passWordLogin.password.length < 6) {
                    state.MessageTitle = 'phoneLogin.errorMessageTitle'
                    state.MessageContent = 'phoneLogin.emailPasswordInputError'
                    state.MessageButton = 'phoneLogin.MessageButton'
                    state.dialogFontIsShow = true
                } else {
                    let res = await loginPassword(state.passWordLogin)
                    if (res.code == 200) {
                        props.setUserInfo(res)
                    } else {
                        state.MessageTitle = 'phoneLogin.errorMessageTitle'
                        state.msgMessageContent = res.msg
                        state.MessageButton = 'phoneLogin.MessageButton'
                        state.dialogFontIsShow = true
                    }
                }
            } else {
                state.MessageTitle = 'phoneLogin.errorMessageTitle'
                state.MessageContent = 'phoneLogin.emailPasswordInputError'
                state.MessageButton = 'phoneLogin.MessageButton'
                state.dialogFontIsShow = true
            }
        }
        // 手机验证码和密码登录
        async function loginBut() {
            if (state.formData.phone != '' && state.formData.phonePassword != '') {
                if (state.loginType == 1) {// 手机验证码登录
                    let res = await loginPhone({
                        phone: state.checkedCode + '-' + state.formData.phone,
                        phone_code: state.formData.phonePassword
                    })
                    if (res.code == 200) {
                        props.setUserInfo(res)
                    } else {
                        state.MessageTitle = 'phoneLogin.errorMessageTitle'
                        state.msgMessageContent = res.msg
                        state.MessageButton = 'phoneLogin.MessageButton'
                        state.dialogFontIsShow = true
                    }
                } else if (state.loginType == 2) { // 密码登录
                    let res = await loginPassword({
                        username: state.checkedCode + '-' + state.formData.phone,
                        password: state.formData.phonePassword
                    })
                    if (res.code == 200) {
                        props.setUserInfo(res)
                    } else {
                        state.MessageTitle = 'phoneLogin.errorMessageTitle'
                        state.msgMessageContent = res.msg
                        state.MessageButton = 'phoneLogin.MessageButton'
                        state.dialogFontIsShow = true
                    }
                }
            } else { // 输入框值为空
                state.MessageTitle = 'phoneLogin.errorMessageTitle'
                state.MessageContent = 'phoneLogin.emptyInput'
                state.MessageButton = 'phoneLogin.MessageButton'
                state.dialogFontIsShow = true
            }
        }
        // 返回中文或英文国际区号  // 其他语言暂时没写
        function setSelectPhoneItem(val) {
            if (state.lang == 'zh-cn' || state.lang == 'zh-tw') {
                return val.country_zh
            } else {
                return val.country_en
            }
        }
        // 选择区号箭头指向
        function rotateIconBut() {
            state.rotateIcon = !state.rotateIcon
        }
        // 选中区号
        function pickCode(val) {
            state.checkedCode = val.tel_code
            state.rotateIcon = false
        }
        // 获取区号
        
        async function getData() {
            let res = await getShowTelCode()
            state.regionList = codetext(res.data.city)
        }
        // 国际区号排序
        function codetext(cities) {
            let list = [];        //  获取a-z大写数组；
            let textlist = [];    //  组合数组。
            for (let i = 0; i < 26; i++) {
                list.push(String.fromCharCode(65 + i))
            }
            let data;
            let language = localStorage.getItem('2d3d-language')
            if (language) {
                data = language
            } else {
                data = 'en-us'
            }
            if (data == 'zh-Hans' || data == 'zh-Hant' || data == "zh-tw" || data == 'zh-cn') {
                list.forEach((leter) => {
                    let datalist = cities.filter((text) => String(text.pinyin).substr(0, 1).toUpperCase() === leter
                    );
                    if (datalist && datalist.length > 0) {
                        textlist.push({
                            type: leter,
                            datalist: datalist,
                        });
                    }
                });
            } else {
                list.forEach((leter) => {
                    let datalist = cities.filter(text => String(text.country_en).substr(0, 1).toUpperCase() === leter);
                    if (datalist && datalist.length > 0) {
                        textlist.push({
                            type: leter,
                            datalist: datalist,
                        });
                    }
                });

            }
            return textlist;
        }
        return {
            ...toRefs(state),
            verify,
            rotateIconBut,
            pickCode,
            setSelectPhoneItem,
            loginBut,
            success,
            userPhone,
            sendCode,
            loginTypeBut,
            submitLogin,
            resetQrCode,
            getBackSendCode,
            getBackSubmit,
            dialogFontIsShowBut,
            goWxLogin,
            goAppleLogin,
            goGoogleLogin
        }
    }
}
</script>

<style lang="scss" scoped>
@font-face {
    font-family: BoldFonts;
    src: url('@/fonts/PingFang-SC-Bold.ttf');
}

.login-main {
    box-sizing: border-box;
    background: #ebeaea;
    position: relative;
    height: 100%;
    font-family: BoldFonts;

    &* {
        box-sizing: border-box;
    }

    // 找回密码
    .retrieve-password {
        cursor: pointer;
        font-size: 0.16rem;
        color: #959595;
        padding: 0.2rem;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
    }

    // 其他登录方式
    .other-login {
        width: 3.8rem;
        padding: 0.2rem;
        margin: 0 auto;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;

        .other-title {
            font-size: 0.16rem;
            text-align: center;
            color: #959595;
            margin-bottom: 0.3rem;
        }

        .other-item {
            display: flex;
            justify-content: space-around;

            .other-item-wx {
                width: 0.65rem;
                height: 0.65rem;
                display: block;
                cursor: pointer;
            }

            .other-item-pg {
                width: 0.65rem;
                height: 0.65rem;
                display: block;
                cursor: pointer;
            }

            #googleBtn {
                width: 0.65rem;
                height: 0.65rem;
            }

            #googleBtn:deep(.JGcpL-RbRzK) {
                -webkit-border-radius: 0.3rem;
            }

            #googleBtn:deep(.nsm7Bb-HzV7m-LgbsSe) {
                width: 0.65rem !important;
                height: 0.65rem !important;
            }

            #googleBtn:deep(.nsm7Bb-HzV7m-LgbsSe-Bz112c) {
                padding: 0.1rem;

            }

            #googleBtn:deep(.nsm7Bb-HzV7m-LgbsSe-Bz112c) {
                height: 0.3rem;
                min-width: 0.3rem;
                width: 0.3rem;
            }

            #googleBtn:deep(.nsm7Bb-HzV7m-LgbsSe-bN97Pc-sM5MNb) {
                justify-content: center;
            }
        }
    }

    // 弹窗信息
    .dialog-message {
        width: 3rem;
        background: #e5e4e4;
        position: absolute;
        top: 1rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        padding: 0.1rem;
        box-sizing: border-box;
        border-radius: 0.1rem;

        .dialog-message-title {
            font-size: 0.2rem;
            font-weight: 700;
            text-align: center;
        }

        .dialog-message-content {
            font-size: 0.16rem;
            margin: 0.1rem 0;
            color: #999;
            text-align: center;
        }

        .dialog-message-button {
            font-size: 0.16rem;
            height: 0.48rem;
            line-height: 0.48rem;
            text-align: center;
            border-top: #f2f2f2 solid 0.01rem;
            color: #007add;
            cursor: pointer;
        }
    }

    .top-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.3rem;

        .top-left {
            color: #343434;
            font-size: 0.25rem;
            font-family: BoldFonts;
            font-weight: 700;
        }

        .top-getBack {
            width: 2.2rem;
        }

        .top-right {
            display: flex;
            font-size: 0.14rem;
        }

        .get-password {
            font-size: 0.14rem;
            width: 1.2rem;
            text-align: right;
        }
    }

    // 手机验证码，密码登录

    .password-login-box {
        width: 4.5rem;
        height: 2.16rem;
        background: rgb(255, 255, 255);
        border-radius: 15px;
        padding: 0.2rem;
        box-sizing: border-box;

        .password-line {
            width: 100%;
            border-bottom: 0.01rem solid #ececec;
        }

        .password-input {
            height: 0.55rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            position: relative;

            input::-webkit-input-placeholder {
                /* placeholder字体大小 */
                font-size: 0.16rem;
            }

            .password-input-left {
                font-size: 0.16rem;
                width: 2rem;
                display: flex;
                align-items: center;


                .rotate-icon {
                    transform: rotate(180deg);
                }
            }

            .select-phone {
                width: 3rem;
                max-height: 2.5rem;
                background: rgba($color: #ffffff, $alpha: 1.0);
                position: absolute;
                top: 0.5rem;
                z-index: 10;
                overflow: auto;
                padding: 0.12rem;
                box-sizing: border-box;
                border: #9c9a9a solid 0.01rem;

                .select-phone-type {
                    height: 0.22rem;
                    background: #f6f6f6;
                    width: 100%;
                    font-size: 0.15rem;
                }

                .select-phone-item {
                    display: flex;
                    justify-content: space-between;
                    height: 0.22rem;
                    width: 100%;
                    font-size: 0.15rem;
                    line-height: 0.22rem;
                }
            }

            .password-input-right {
                display: block;
                border: none;
                outline: none;
                width: 100%;
                height: calc(100% - 2px);
                padding-left: 0.1rem;
                font-family: BoldFonts;
                font-size: 0.16rem;
            }

            .password-input-send {
                width: 4.5rem;
                font-size: 0.15rem;
                padding-left: 0.1rem;
                box-sizing: border-box;
                text-align: center;
            }

            .sendCodeTime {
                text-align: center;
                color: rgb(153, 153, 153);
                font-size: 0.16rem;
            }
        }

        .password-login {
            width: 100%;
            font-size: 0.18rem;
            background-color: rgb(61, 99, 196);
            height: 0.46rem;
            color: #fff;
            opacity: 1;
            text-align: center;
            line-height: 0.46rem;
            border-radius: 0.05rem;
            margin-top: 0.2rem;
            padding: 0 5%;
            box-sizing: border-box;
            cursor: pointer;
        }
    }

    // 二维码登录
    .Qr-code-login {
        background: #fff;
        width: 4.5rem;
        padding: 0.2rem;
        margin: 0px auto;
        border-radius: 0.15rem;
        box-sizing: border-box;

        .VueQrcode-box {
            display: flex;
            justify-content: center;
            position: relative;
            cursor: pointer;

            .qrcode-img {
                background: #fff;
                width: 0.4rem;
                height: 0.4rem;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto auto;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 0.01rem;

                img {
                    width: 0.3rem;
                    height: 0.3rem;
                    display: block;

                }
            }
        }

        .VueQrcode-fonts {
            font-size: 0.16rem;
            text-align: center;
        }

    }

    // 邮箱登录
    .email-login {
        background: #fff;
        width: 4.5rem;
        padding: 0.2rem;
        margin: 0px auto;
        border-radius: 0.15rem;
        box-sizing: border-box;

        .email-login-input {
            display: block;
            width: 100%;
            height: 0.55rem;
            border: none;
            outline: none;
            font-size: 0.16rem;
        }

        input::-webkit-input-placeholder {
            /* placeholder字体大小 */
            font-size: 0.16rem;
        }

        .email-login-input-line {
            border-bottom: 0.01rem solid #ececec;
        }

        .email-login-button {
            width: 100%;
            font-size: 0.18rem;
            background: #3d63c4;
            height: 0.46rem;
            color: #fff;
            opacity: .5;
            text-align: center;
            line-height: 0.46rem;
            border-radius: 0.05rem;
            margin-top: 0.2rem;
            padding: 0 5%;
            box-sizing: border-box;
            cursor: pointer;
            opacity: 1;
        }
    }

    // 邮箱或手机号找回密码
    .getPhoneOrEmailPassword-box {
        width: 4.5rem;
        background: #fff;
        padding: 0.17rem;
        box-sizing: border-box;
        border-radius: 0.1rem;

        .phone-email-input {
            height: 0.55rem;
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;

            .phone-code {
                font-size: 0.16rem;
                // width: 2rem;
                display: flex;
                align-items: center;
                margin-right: 0.1rem;

                .rotate-icon {
                    transform: rotate(180deg);
                }
            }

            .select-phone {
                width: 3rem;
                max-height: 2.5rem;
                background: rgba($color: #ffffff, $alpha: 1.0);
                position: absolute;
                top: 0.5rem;
                z-index: 10;
                overflow: auto;
                padding: 0.12rem;
                box-sizing: border-box;
                border: #9c9a9a solid 0.01rem;

                .select-phone-type {
                    height: 0.22rem;
                    background: #f6f6f6;
                    width: 100%;
                    font-size: 0.15rem;
                }

                .select-phone-item {
                    display: flex;
                    justify-content: space-between;
                    height: 0.22rem;
                    width: 100%;
                    font-size: 0.15rem;
                    line-height: 0.22rem;
                }
            }

            .import-input-PorE {
                display: block;
                width: 100%;
                border: none;
                outline: none;
                padding-left: 0.1rem;
                font-size: 0.16rem;
                font-family: BoldFonts;
            }



            .getpassword-send-code {
                color: rgb(61, 99, 196);
                cursor: pointer;
                width: 1.5rem;
                font-size: 0.15rem;
                padding-left: 0.1rem;
                box-sizing: border-box;
                text-align: center;
            }

            input::-webkit-input-placeholder {
                /* placeholder字体大小 */
                font-size: 0.16rem;
            }
        }

        .input-line {
            width: 100%;
            border-bottom: 0.01rem solid #ececec;
        }

        input::-webkit-input-placeholder {
            /* placeholder字体大小 */
            font-size: 0.16rem;
        }

        .import-code-input {
            display: block;
            width: 100%;
            border: none;
            outline: none;
            padding-left: 0.1rem;
            height: 0.55rem;
            font-size: 0.16rem;
            font-family: BoldFonts;
        }

        .getBack-Button {
            width: 100%;
            height: 0.46rem;
            background: #3d63c4;
            border-radius: 0.05rem;
            margin-top: 0.1rem;
            color: #fff;
            font-size: 0.2rem;
            line-height: 0.46rem;
            text-align: center;
            opacity: 1;
            cursor: pointer;
        }
    }
}
</style>